<template>
   <div v-if="all" class="zone-button all" :class="{active: active}" @click="allClick">All</div>
   <div v-else class="zone-button" @click="zoneClick" :class="{active: active, zoneHidden: hideZone, highlight_zone: isHighlight}">Zone {{zoneId/1000}}</div>
</template>

<script>
export default {
   data() {
      return {
         hideZone: false,
      }
   },

   props: {
      zoneId: Number,
      active: Boolean,
      all: Boolean,
      isHidden: Boolean,
      isHighlight: Boolean
   },

   methods: {
      zoneClick() {
         this.hideZone = !this.hideZone;
         this.$emit('zoneToggle', this.hideZone, this.zoneId);
      },

      allClick() {
         this.$emit('allToggle');
      }
   },

   watch: {
      isHidden: function() {
         if (!this.isHidden) {
            this.hideZone = false;
         }
      }
   }
}
</script>

<style <style lang="scss" scoped>
.zone-button {
   padding-left: 15px;
   padding-right: 15px;
   cursor: pointer;
   text-transform: uppercase;
   position:relative;

   display: none;

   &.active {
      display: block;
   }

   &.zoneHidden {
      color: #aaaaaa;
   }

   &.all {
      display: block;
      &.active {
         background: $bard-gold;
      }
   }

   &.highlight_zone {
      &:after {
         content: '';
         display: block;
         position: absolute;
         left: 33px;
         bottom: -4px;
         width: 5px;
         height: 5px;
         -moz-border-radius: 7.5px;
         -webkit-border-radius: 7.5px;
         border-radius: 7.5px;
         background-color: $bard-gold;
      }
   }
}
</style>

